import { ScoreItem } from '@talentmesh/utils';
import { useCandidatesResultsContext } from '../../Contexts/CandidateResultsContext';
import ScoreOverview from './Components/ScoreOverview';
import PersonalityScoreDetails from './Personality/PersonalityScoreDetails';
import UIStrings from '@/Utils/UIStrings';

function PersonalityTab() {
    const { results, jobFunction } = useCandidatesResultsContext();
    const { personalityScore, candidateFirstName } = results;

    if (personalityScore) {
        const { percentileScore, percentileLevel, testValidity } = personalityScore;

        const overall: ScoreItem = {
            level: percentileLevel,
            name: UIStrings.OverallScore,
            value: percentileScore,
        };

        const scores: ScoreItem[] = personalityScore.factors.map((factor) => {
            return {
                level: factor.percentileLevel,
                name: factor.factorName,
                value: factor.percentileScore,
            };
        });

        return (
            <div className="mb-2.5 flex flex-col gap-2.5">
                <ScoreOverview
                    scoreOverviewTitle={UIStrings.PersonalityScoreOverview}
                    scoreOverviewDescription={UIStrings.AnOverallScoreIsCalculated(jobFunction)}
                    candidateFirstName={candidateFirstName}
                    scores={scores}
                    overall={overall}
                    testValidity={testValidity}
                />
                <PersonalityScoreDetails />
            </div>
        );
    }
    return null;
}

export default PersonalityTab;
